import React from "react";
import { TrendInfo, ChartValue } from "../../types";

import {
  VictoryAxis,
  VictoryChart,
  VictoryLine,
  VictoryTooltip,
  VictoryVoronoiContainer,
} from "victory";

import currency from "currency.js";

export interface Props {
  data: ChartValue[];
  projectedData?: ChartValue[];
}

const Chart = ({ data, projectedData }: Props) => {
  return (
    <div id="chart">
      <VictoryChart
        domainPadding={50}
        width={1000}
        height={500}
        scale={{ x: "time" }}
        containerComponent={
          <VictoryVoronoiContainer
            labels={({ datum }) => `${Math.round(Number(datum.value))}`}
            labelComponent={<VictoryTooltip style={{ fontSize: 30 }} />}
          />
        }
      >
        <VictoryLine
          data={data}
          x="slice"
          y="value"
          style={{
            data: { stroke: "#36c7ff", opacity: 0.6, strokeWidth: 10 },
          }}
          animate={{ duration: 2000, onLoad: { duration: 1000 } }}
        />
        {projectedData && (
          <VictoryLine
            data={projectedData}
            x="slice"
            y="value"
            style={{
              data: { stroke: "#ff3636", opacity: 0.3, strokeWidth: 10 },
            }}
            animate={{ duration: 2000, onLoad: { duration: 1000 } }}
          />
        )}
        <VictoryAxis
          style={{
            axis: { stroke: "#756f6a" },
            tickLabels: { fontSize: 15, padding: 15, angle: 45 },
            axisLabel: { fontSize: 25, padding: 30 },
            grid: { stroke: "grey", opacity: 0.3 },
          }}
        />
        <VictoryAxis
          dependentAxis={true}
          tickFormat={(x) =>
            `${currency(x, {
              format: (value, options) => {
                const val = value?.value ? Math.abs(value.value) : 0;
                if (val > 1000000) {
                  return `${x / 1000000}m`;
                } else if (val > 1000) {
                  return `${x / 1000}k`;
                } else {
                  return currency(val).format();
                }
              },
            }).format()}`
          }
          style={{
            tickLabels: { fontSize: 15, padding: 5, angle: -45 },
          }}
        />
      </VictoryChart>
    </div>
  );
};

export default Chart;
